// src/pages/firm/SyncConfigDialog.tsx
import React from "react";
import { Dialog } from "primereact/dialog";
import { IconTextButton } from "../../components/ButtonComponents";
import { X, Copy } from "lucide-react";
import { toast } from "react-toastify";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  config: any;
  firmName: string;
}

export const SyncConfigDialog: React.FC<Props> = ({ isOpen, onClose, config, firmName }) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(JSON.stringify(config, null, 2));
    toast.info("Kopyalandı!");
  };

  return (
    <Dialog
      header={`${firmName} - Sync Yapılandırması`}
      visible={isOpen}
      onHide={onClose}
      className="w-full md:w-6/12"
      footer={
        <div className="flex justify-between">
          <IconTextButton onClick={copyToClipboard} icon={Copy} className="btn-light">Kopyala</IconTextButton>
          <IconTextButton onClick={onClose} icon={X} className="btn-cancel">Kapat</IconTextButton>
        </div>
      }
    >
      <pre className="bg-slate-900 text-green-400 p-4 rounded-md overflow-auto max-h-96 text-xs font-mono">
        {JSON.stringify(config, null, 2)}
      </pre>
    </Dialog>
  );
};